<template>
    <div>
        <b-modal
            id="pop-up-checker"
            title="Pop-Up-Blocker deaktivieren"
            ok-only
        >
            <p class="my-4">
                Um die Druckvorschau anzeigen zu können, müssen Sie den Pop-Up-Blocker Ihres Browsers für diese Seite deaktivieren.<br>
                Um die entsprechenden Einstellungen zu ändern, folgen Sie bitte der entsprechenden Anleitung für Ihren verwendeten Browser:
            </p>
            <p>
                <strong>Chrome:</strong> <a href="https://support.google.com/chrome/answer/95472" target="_blank">www.support.google.com</a><br>
                <strong>Mozilla:</strong> <a href="https://support.mozilla.org/de/kb/pop-blocker-einstellungen-ausnahmen-problemloesung" target="_blank">www.support.mozilla.org</a><br>
                <strong>Edge:</strong> <a href="https://support.microsoft.com/de-de/microsoft-edge/blockieren-von-popups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5" target="_blank">www.support.microsoft.com</a><br>
                <strong>Safari:</strong> <a href="https://support.apple.com/de-de/guide/safari/sfri40696/mac" target="_blank">www.support.apple.com</a><br>
            </p>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "PopUpChecker"
}
</script>